import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import EssayDefault from './Default';
import EssayPlayful from './Playful';

export function Essay(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();

  return isPlayfulStudentTheme ? <EssayPlayful {...props} /> : <EssayDefault {...props} />;
}
